export default "__VITE_ASSET__C_8V7eo6__"